export default __webpack_public_path__ + "static/media/project1.6c48d1e9.jpeg";